import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class HelpOverlay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    // white background
    this.bg = this.scene.add.rectangle(0,0,this.scene.scale.width, this.scene.scale.height, 0xffffff).setAlpha(0.4)
      .setOrigin(0);
    this.add(this.bg);

    this.helpOverlay = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._HelpDisplay_n, this).setOrigin(0);
    this.helpOverlay.x = this.scene.scale.width / 2 - this.helpOverlay.width / 2;
    this.helpOverlay.y = 40;

    ABCyaPhaser.Container.setContainerInteractive(this, false);
  }
}